<div class="dialog-wrapper">
  <app-modal-header-common [title]="'Action Central'" [dialogRef]="dialogRef">
  </app-modal-header-common>
  <app-loading *ngIf="loading"></app-loading>
  <ng-container *ngIf="!loading">
  <div class="dialog-content">
    <div class="plan-form">
      <form [formGroup]="actionForm">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Title</mat-label>
          <textarea
            matInput
            formControlName="title"
            required
            rows="3 "
            [matTooltip]="actionForm.get('title')?.value"
            matTooltipPosition="right"
            matTooltipShowDelay="200"
          ></textarea>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description" required rows="4">
          </textarea>
        </mat-form-field>
        <div class="row" *ngIf="actionForm.controls.id.value">
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Assigned Date</mat-label>
              <input
                matInput
                formControlName="assigned_date"
                [disabled]="true"
              />
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Assigned By</mat-label>
              <input matInput formControlName="assigned_by" [disabled]="true" />
            </mat-form-field>
          </div>
        </div>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Assignee</mat-label>
          <mat-select
            formControlName="assignee_ids"
            required
            multiple
            disableOptionCentering="true"
            (openedChange)="onAssigneeDropdownClose($event)">
            <mat-select-trigger>
              {{ getSelectedAssigneesLabel() }}
            </mat-select-trigger>
            <div
              class="p-2 sticky-top bg-white"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()">
              <input
                matInput
                class="form-control form-control-sm"
                placeholder="Search Assignee..."
                [(ngModel)]="assigneeSearchText"
                [ngModelOptions]="{ standalone: true }" />
            </div>
            <mat-option *ngFor="let user of filteredAssignees" [value]="user.id">
              {{ user?.first_name }} {{ user?.last_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="row">
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status" required>
                <mat-option
                  *ngFor="let opt of statusOptionsList"
                  [value]="opt.name"
                  >{{ opt.display_name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Due Date</mat-label>
              <input
                matInput
                [matDatepicker]="dueDatePicker"
                formControlName="due_date"
                readonly
                required
                (click)="dueDatePicker.open()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dueDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #dueDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Category</mat-label>
              <mat-select
                formControlName="action_tracker_type"
                required
                (selectionChange)="onCategorySelection($event.value)"
              >
                <mat-option
                  *ngFor="let cat of actionTrackerCategory"
                  [value]="cat.id"
                >
                  {{ cat.display_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-sm-6">
            <ng-container *ngFor="let cat of filteredActionTrackerCategory">
              <div
                *ngIf="actionForm.controls.action_tracker_type.value == cat.id"
              >
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label mat>{{ cat.display_name }}</mat-label>
                  <mat-select formControlName="type_id" required>
                    <mat-option
                      *ngFor="let opt of getOptionsForCategory(cat)"
                      [value]="opt.id"
                    >
                      {{
                        opt?.opportunity_name ||
                          opt?.project_name ||
                          opt?.display_name ||
                          opt?.name ||
                          opt?.title ||
                          opt?.clause_title ||
                          opt?.description ||
                          opt?.action_tasks
                      }}
                    </mat-option>
                  </mat-select>
                  <!-- Info icon shown when a value exists (prefilled) -->
                  <button
                    *ngIf="actionForm.get('type_id')?.value"
                    class="show-more-btn"
                    matSuffix
                    mat-icon-button
                    [matMenuTriggerFor]="clauseMenu"
                  >
                    <mat-icon matTooltip="Show more" class="show-more-icon"
                      >info</mat-icon
                    >
                  </button>
                  <mat-menu #clauseMenu="matMenu" class="requirement-menu">
                    <div
                      class="popover-content"
                      style="
                        padding: 15px;
                        max-width: 400px;
                        white-space: normal;
                      "
                    >
                      {{ selectedOptionLabel() || staticText.no_data_found }}
                    </div>
                  </mat-menu>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
        </div>

        <div
          class="row"
          *ngIf="
            actionForm.get('status')?.value === 'Closed' || actor === 'reviewer'
          "
        >
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Completion Date</mat-label>
              <input
                matInput
                [matDatepicker]="completionDatePicker"
                formControlName="completion_date"
                (click)="completionDatePicker.open()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="completionDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #completionDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="showLinkedAction">
          <div class="col-sm-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Linked Action</mat-label>
              <mat-select formControlName="linked_action">
                <mat-option *ngFor="let opt of actionsList" [value]="opt.id">{{
                  opt.title
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <mat-accordion
          *ngIf="showLinkedAction && actionForm.get('linked_action')?.value"
        >
          <mat-expansion-panel (opened)="onLinkedActionAccordionOpened()">
            <mat-expansion-panel-header>
              <mat-panel-title> Linked Action Details </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngIf="loadingLinkedAction" class="text-center py-3">
              <app-loading style="margin: 0 auto"></app-loading>
            </div>

            <div
              *ngIf="!loadingLinkedAction && linkedActionDetails"
              class="p-2"
            >
              <div class="mb-2">
                <div class="fw-bold">Title:</div>
                <span>{{ linkedActionDetails?.title || "-" }}</span>
              </div>
              <div class="mb-2">
                <div class="fw-bold">Description:</div>
                <span style="white-space: pre-line;">{{ linkedActionDetails?.description || "-" }}</span>
              </div>
              <div class="row mb-2">
                <div class="col-sm-6">
                  <div class="fw-bold">Assigned Date:</div>
                  <span>{{ linkedActionDetails?.assigned_date || "-" }}</span>
                </div>
                <div class="col-sm-6">
                  <div class="fw-bold">Assigned By:</div>
                  <span>{{ linkedActionDetails?.assigned_by || "-" }}</span>
                </div>
              </div>
              <div class="mb-2">
                <div class="fw-bold">Assignee:</div>
                <span>
                  {{
                    [
                      linkedActionDetails?.assignee[0]?.first_name,
                      linkedActionDetails?.assignee[0]?.last_name,
                    ].join(" ")
                  }}
                </span>
              </div>
              <div class="row mb-2">
                <div class="col-sm-6">
                  <div class="fw-bold">Status:</div>
                  <span>{{ linkedActionDetails?.status || "-" }}</span>
                </div>
                <div class="col-sm-6">
                  <div class="fw-bold">Due Date:</div>
                  <span>{{ linkedActionDetails?.due_date || "-" }}</span>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-sm-6">
                  <div class="fw-bold">Category:</div>
                  <span>{{ linkedActionCategoryLabel || "-" }}</span>
                </div>
                <div class="col-sm-6" *ngIf="linkedActionDetails?.type_id">
                  <div class="fw-bold">
                    {{ linkedActionCategoryLabel || "Type" }}:
                  </div>
                  <span>{{ linkedActionTypeLabel || "-" }}</span>
                </div>
              </div>
              <div
                class="row mb-2"
                *ngIf="linkedActionDetails?.status === 'Closed'"
              >
                <div class="col-sm-6">
                  <div class="fw-bold">Completion Date:</div>
                  <span>{{ linkedActionDetails?.completion_date || "-" }}</span>
                </div>
              </div>
              <div class="mb-2" *ngIf="linkedActionDetails?.comments">
                <div class="fw-bold">Comments:</div>
                <span style="white-space: pre-line;">{{ linkedActionDetails?.comments }}</span>
              </div>

              <div class="mb-2" *ngIf="linkedActionDetails?.task?.key_outcome">
                <div class="fw-bold">Key outcome:</div>
                <span style="white-space: pre-line;">{{ linkedActionDetails?.task?.key_outcome }}</span>
              </div>

              <div
                class="mb-2"
                *ngIf="linkedActionDetails?.task?.required_documents?.length"
              >
                <div class="fw-bold mb-2">Required Documents:</div>
                <div class="d-flex flex-wrap gap-1">
                  <span
                    *ngFor="
                      let doc of linkedActionDetails?.task?.required_documents
                    "
                    class="badge d-flex align-items-center"
                    [ngClass]="doc.is_mandatory ? 'bg-danger' : 'bg-secondary'"
                    style="padding: 6px 8px; font-size: 12px"
                  >
                    {{ doc.document_name }}
                    <span
                      style="margin-left: 4px; font-size: 10px; opacity: 0.85"
                    >
                      ({{ doc.is_mandatory ? "Mandatory" : "Optional" }})
                    </span>
                  </span>
                </div>
              </div>

              <div class="mb-2" *ngIf="linkedActionDetails?.files?.length">
                <div class="fw-bold mb-2">Files:</div>
                <div class="d-flex flex-wrap gap-2">
                  <div
                    *ngFor="let file of linkedActionDetails?.files"
                    class="d-flex align-items-center justify-content-between p-2 border rounded bg-white"
                    style="width: 200px"
                  >
                    <div class="d-flex align-items-center w-75">
                      <mat-icon class="me-1">insert_drive_file</mat-icon>
                      <span
                        [matTooltip]="file.file_name"
                        class="filename-ellipsis"
                        >{{ file.file_name }}</span
                      >
                    </div>
                    <button
                      mat-icon-button
                      matTooltip="Download"
                      (click)="
                        downloadLinkedActionFile(file.id, file.file_name)
                      "
                    >
                      <mat-icon>cloud_download</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="mb-2" *ngIf="linkedActionDetails?.plans?.length">
                <div class="fw-bold mb-2">Associated Plans:</div>
                <div class="d-flex flex-wrap gap-1">
                  <span
                    *ngFor="let plan of linkedActionDetails.plans"
                    class="badge bg-secondary"
                    style="padding: 6px 8px; font-size: 12px"
                  >
                    {{ plan?.name }}
                  </span>
                </div>
              </div>
              <div>
                <app-action-history
                  [actionId]="linkedActionDetails.id"
                ></app-action-history>
              </div>
            </div>

            <div
              *ngIf="!loadingLinkedAction && !linkedActionDetails"
              class="text-center py-2"
            >
              {{ staticText.no_data_found }}
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <mat-form-field class="w-100 mt-4" appearance="outline">
          <mat-label>Comments</mat-label>
          <textarea matInput formControlName="comments"> </textarea>
        </mat-form-field>

        <div class="mb-3" *ngIf="data.actionData?.task?.key_outcome">
          <div class="fw-bold mb-2">Key outcome:</div>
          <span>
            {{ data.actionData?.task?.key_outcome }}
          </span>
        </div>

        <div
          class="mb-3"
          *ngIf="data.actionData?.task?.required_documents?.length"
        >
          <div class="fw-bold mb-2">Required Documents:</div>
          <div class="d-flex flex-wrap gap-1">
            <span
              *ngFor="let doc of data.actionData?.task?.required_documents"
              class="badge d-flex align-items-center"
              [ngClass]="doc.is_mandatory ? 'bg-danger' : 'bg-secondary'"
              style="padding: 6px 8px; font-size: 12px"
              [matTooltip]="doc.is_mandatory ? 'Mandatory' : 'Optional'"
              matTooltipPosition="above"
            >
              {{ doc.document_name }}
              <span style="margin-left: 4px; font-size: 10px; opacity: 0.85">
                ({{ doc.is_mandatory ? "Mandatory" : "Optional" }})
              </span>
            </span>
          </div>
        </div>
        <div class="mb-3">
          <div
            class="upload-box p-3 rounded border"
            style="background-color: #f9f9f9; position: relative"
          >
            <!-- Hidden File Input -->
            <input
              #fileUpload
              type="file"
              (change)="onFileSelected($event)"
              multiple
              style="display: none"
            />

            <!-- Upload Button -->
            <button
              mat-stroked-button
              color="primary"
              (click)="fileUpload.click()"
              type="button"
            >
              <mat-icon class="me-2">cloud_upload</mat-icon>
              Upload File
            </button>

            <!-- New Uploads: Horizontal Scroll -->
            <div
              class="d-flex gap-3 mt-3"
              style="overflow-x: auto; white-space: nowrap"
            >
              <div
                *ngFor="let file of uploadFiles; let i = index"
                class="d-flex justify-content-between p-2 border rounded bg-white"
                style="width: 200px"
              >
                <div class="d-flex align-items-center w-75">
                  <mat-icon class="me-1">insert_drive_file</mat-icon>
                  <span [matTooltip]="file.name" class="filename-ellipsis">{{
                    file.name
                  }}</span>
                </div>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="removeFile(i)"
                  matTooltip="Remove"
                  style="float: right"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <div
                *ngFor="let file of uploadedFiles; let i = index"
                class="d-flex justify-content-between p-2 border rounded bg-white"
                style="width: 200px"
              >
                <div class="d-flex align-items-center w-50">
                  <mat-icon class="me-1">insert_drive_file</mat-icon>
                  <span
                    [matTooltip]="file.file_name"
                    class="filename-ellipsis"
                    >{{ file.file_name }}</span
                  >
                </div>
                <button
                  mat-icon-button
                  matTooltip="Download"
                  (click)="downloadFile(file.id, i)"
                >
                  <mat-icon>cloud_download</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Remove"
                  (click)="removeUploadedFile(file.id, i)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Associated Plans</mat-label>
          <mat-chip-list #planChipList aria-label="Plans selection">
            <mat-chip
              *ngFor="let plan of selectedPlans; let i = index"
              [selectable]="true"
              [removable]="true"
              (removed)="removePlan(i)"
            >
              <b>{{ plan?.display_name }}</b>
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
              type="text"
              placeholder="Search plans..."
              [formControl]="planUserInputControl"
              [matChipInputFor]="planChipList"
              [matChipInputAddOnBlur]="true"
              [matAutocomplete]="planAuto"
              #planOperationTrigger="matAutocompleteTrigger"
              name="plan_name"
              (click)="planOperationTrigger.openPanel()"
            />
          </mat-chip-list>

          <mat-autocomplete
            #planAuto="matAutocomplete"
            (optionSelected)="addPlan($event.option.value)"
          >
            <mat-option
              *ngFor="let option of plansFilteredOptions | async"
              [value]="option"
            >
              <b>{{ option?.display_name }}</b>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </div>
    <div>
      <app-action-history
        [actionId]="actionForm.controls.id.value"
        #actionHistory
      ></app-action-history>
    </div>
  </div>
  <div
    style="display: flex; justify-content: space-between"
    class="modal-footer"
  >
    <div>
      <!-- Tooltip on a wrapper: a disabled button ignores the mouse, so its own would not show. -->
      <span *ngIf="showAiroButton()" [matTooltip]="airoLocked ? airoLockedText : ''">
        <button
          mat-icon-button
          aria-label="Ask Airo"
          class="airo-ico-action"
          matTooltip="Ask Airo"
          matTooltipPosition="above"
          [disabled]="airoLocked"
          (click)="openAiroDialog()"
        >
          <mat-icon *ngIf="airoLocked" class="btn-lock">lock</mat-icon>
          <img src="/assets/Icons/airoIcon.png" height="20px" />
        </button>
      </span>
    </div>
    <div>
      <button
        (click)="closeModal()"
        mat-button
        mat-dialog-close
        color="primary"
        class="mx-2"
      >
        Close
      </button>
      <button
        mat-flat-button
        mat-button
        color="primary"
        [disabled]="
          actionForm.get('id')?.value
            ? actionForm.invalid || (!actionForm.dirty && !uploadFiles.length)
            : actionForm.invalid
        "
        (click)="actionForm.get('id')?.value ? updateAction() : createAction()"
      >
        {{ actionForm.get("id")?.value ? "Update" : "Create" }}
      </button>
    </div>
  </div>
  </ng-container>
</div>
